import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'

export const ChangePasswordFormWrapper = styled.div`
  margin-top: 40px;
  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    margin-top: 24px;
  }
`

export const AlertWrapper = styled.div`
  padding: 20px 20px 0;
`
export const AlertText = styled.div`
  display: flex;
  flex-direction: column;
`
export const FormGroupField = styled.div`
  width: 100%;
  display: flex;
  margin: auto;
  input {
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    border-radius: 8px;
    height: 47px;
    background-color: ${({ theme }) => theme.color.white};
    padding: 13px 16px;
    font-size: ${variables.fontSize14};
    line-height: 21px;
  }
`
export const Form = styled.form`
  max-width: 400px;
  margin-top: 0;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 24px;
`
export const ChangePasswordFormInput = styled.div`
  margin-bottom: 16px;
  width: 100%;
  position: relative;
`

export const ChangePasswordFormGroup = styled.div`
  margin-bottom: 8px;
  width: 100%;
  position: relative;
`
